import { get } from 'lodash';
import {
  blue,
  blueGrey,
  brown,
  cyan,
  deepPurple,
  green,
  grey,
  indigo,
  orange,
  pink,
  purple,
  red,
  teal,
} from '@material-ui/core/colors';

const colors = [
  deepPurple[300],
  grey[700],
  blue[800],
  blueGrey[700],
  indigo[900],
  brown[900],
  green[800],
  red[400],
  deepPurple[800],
  red[700],
  purple[800],
  green[900],
  pink[900],
  grey[800],
  pink[500],
  blueGrey[900],
  cyan[700],
  deepPurple[500],
  brown[700],
  purple[400],
  brown[500],
  cyan[900],
  pink[700],
  red[900],
  brown[600],
  teal[600],
  purple[600],
  blue[600],
  blue[500],
  pink[800],
  indigo[500],
  indigo[800],
  indigo[700],
  blueGrey[600],
  red[800],
  orange[900],
  grey[600],
  green[600],
  purple[500],
  teal[800],
  teal[500],
  deepPurple[700],
  blue[700],
  teal[900],
  blueGrey[800],
  cyan[800],
  green[700],
  deepPurple[400],
  brown[800],
  purple[700],
  deepPurple[600],
  grey[900],
  purple[300],
  orange[800],
  indigo[600],
  blue[900],
  teal[700],
  pink[600],
];

/**
 * Returns a color that is related to the first character on a string
 * @category Formatters
 * @category String
 */
export function stringToColor(str?: string | null) {
  const firstChar = get(str, '[0]', '').toLowerCase();
  const indexFromChar = (firstChar.charCodeAt(0) - 97) % colors.length;
  const randomIndex = Math.floor(Math.random() * (colors.length - 1));

  return indexFromChar >= 0 ? colors[indexFromChar] : colors[randomIndex];
}
